import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WebservicesService} from './webservices/webservices.service';
import {ScriptService} from './script/script.service';
import {UserSessionService} from './user-session/user-session.service';
import {EventsService} from './event/event.service';
import {UtilsService} from './utils/utils.service';
import {LobbyService} from './lobby/lobby.service';
import {GameHubControllerService} from './gameHub/game-hub-controller';
import {GameHub} from './gameHub/game-hub';
import {JurisdictionService} from './geo/jurisdiction.service';
import {GeoComplyService} from './geo/geo-comply.service';
import {GeoComplyOobeeService} from './geo/geo-comply-oobee.service';
import {PopoverModule} from '../popovers/popover.module';
import {AppLinksService} from './applinks/app-links.service';
import {CashierService} from './cashier/cashier.service';
import {RewardsService} from './rewards/rewards.service';
import {AddressService} from './address/address.service';
import {LoginService} from './login/login.service';
import {SuccessMessageService} from './message-provider/success-message.service';
import {ConfigurationService} from './configuration/configuration.service';
import {AccountSummaryService} from './account-summary/account-summary.service';
import {BannerService} from './banner/banner.service';
import {GameTransactionsService} from './game-transactions/game-transactions.service';
import {WebcontentService} from './webcontent/webcontent.service';
import {GameHistoryService} from './game-history/game-history.service';
import {MenuStateService} from './menu-state/menu-state.service';
import {SpendLimitService} from './spend-limit/spend-limit.service';
import {NotificationApiService} from './notification-api/notification-api.service';
import {LogoutService} from './logout/logout.service';
import {SiteLocationService} from './site-location/site-location.service';
import {GlobalErrorHandlerService} from './global-errors/global-error-handler.service';
import {FundsIndicatorService} from './funds-indicator/funds-indicator.service';
import {BoydRewardsService} from './boyd-rewards/boyd-rewards.service';
import {LobbyNavigator} from './lobby/lobby-navigator.service';
import {LimitsService} from './limits/limits.service';
import {SiteContentService} from './sitecontent/sitecontent.service';
import {LobbyApiService} from './lobby/lobby.api.service';
import {MarketingNotificationService} from './marketing-notification/marketing-notification.service';
import {OnDepositService} from './on-deposit/on-deposit.service'
import { WebcontentExecuteService } from './webcontent/webcontent-execute.service';
import { SidemenuService } from './lobby/sidemenu.service';
import { DeeplinkRedirectService } from './deeplink-redirect/deeplink-redirect.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, PopoverModule],
  providers: [
    AccountSummaryService,
    AppLinksService,
    BannerService,
    BoydRewardsService,
    EventsService,
    CashierService,
    ConfigurationService,
    GameHub,
    GameHubControllerService,
    GameHistoryService,
    GameTransactionsService,
    GeoComplyService,
    GeoComplyOobeeService,
    GlobalErrorHandlerService,
    JurisdictionService,
    LobbyNavigator,
    LogoutService,
    LobbyService,
    LobbyApiService,
    UserSessionService,
    UtilsService,
    RewardsService,
    AddressService,
    LoginService,
    NotificationApiService,
    SiteContentService,
    SuccessMessageService,
    WebcontentService,
    WebcontentExecuteService,
    WebservicesService,
    ScriptService,
    MenuStateService,
    SiteLocationService,
    SpendLimitService,
    FundsIndicatorService,
    LimitsService,
    MarketingNotificationService,
    OnDepositService,
    SidemenuService,
    DeeplinkRedirectService
  ],
})
export class ServicesSharedModule {}
